<mat-card
  [@slideInBottom]
  data-testid="action-bar-container"
  appearance="outlined"
  class="border-radius"
>
  <div class="bar" [class.bar--collapsed]="collapsed()">
    <div
      class="info"
      [class.pointer]="collapsed()"
      data-testid="action-bar-info"
      (click)="collapsed() ? expand() : undefined"
    >
      <mat-icon class="info__icon" color="primary" data-testid="action-bar-icon">{{
        icon()
      }}</mat-icon>
      <div class="info__text">
        <span class="headline-text" data-testid="action-bar-headline">{{ headline() }}</span>
        <span class="on-surface-medium description" data-testid="action-bar-text">{{
          text()
        }}</span>
      </div>
    </div>

    <button
      class="toggle-btn"
      mat-icon-button
      type="button"
      (click)="toggleCollapsed()"
      [matTooltip]="(collapsed() ? 'COMMON.expand' : 'COMMON.collapse') | translate"
      [attr.aria-label]="(collapsed() ? 'COMMON.expand' : 'COMMON.collapse') | translate"
      [attr.aria-expanded]="!collapsed()"
      data-testid="action-bar-toggle"
    >
      <mat-icon>{{ collapsed() ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>

    <div
      class="actions"
      [class.collapsed]="collapsed()"
      [@slideInBottom]
      data-testid="action-bar-actions"
    >
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>
</mat-card>
